<template>
  <v-container>
    <v-dialog v-model="showLogs" max-width="1200" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            Logs For {{importerName}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs12 lg6>
              <DateRange v-model="dates" rounded solo :minDate="MinDate" :maxDate="MaxDate" :availableDateRange="{ start: MinDate, end: MaxDate }" :min-max-placeholder="formats.prettyDateFormat" :shortcuts="shortcuts" no-arrows :data="availableData" :showAvailableText="false" />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 lg12 class="pa-1">
              <v-text-field outline v-model="queryString" label="Enter Search term" clearable hide-details></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-checkbox v-model="errorsOnly" label="Errors only" hide-details></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="clickSearch();page=1">
            <v-icon left>search</v-icon>Search
          </v-btn>
          <v-btn color="secondary" outline @click="close">Cancel</v-btn>
        </v-card-actions>
        <div v-if="searchLoading">
          <br>
          <v-progress-linear v-if="!searchFinish" :indeterminate="true"></v-progress-linear>
        </div>
        <v-divider></v-divider>
        <v-card-text v-if="searchFinish">
          <v-subheader>Filters:</v-subheader>
          <v-chip disabled style="margin-left: 15px;">
            <v-icon color="primary">bookmark</v-icon>Date Time: {{selectItem.showDateTime}}
          </v-chip>
          <v-chip disabled style="margin-left: 15px;" v-if="selectItem.errorsOnly">
            <v-icon color="primary">bookmark</v-icon>Errors Only: {{selectItem.errorsOnly}}
          </v-chip>
          <v-chip disabled style="margin-left: 15px;" v-if="selectItem.queryString">
            <v-icon color="primary">bookmark</v-icon>Search Term: {{selectItem.queryString}}
          </v-chip>
          <v-subheader>Results:</v-subheader>
          <v-chip disabled style="margin-left: 15px;">
            <v-icon color="primary">pageview</v-icon>{{logsNum}} Logs
          </v-chip>
          <v-divider></v-divider>
          <v-expansion-panel focusable>
            <v-expansion-panel-content v-for="(item,i) in searchResults" :key="i">
              <template v-slot:header>
                <v-layout row wrap>
                  <v-flex xs3 class="word_wrap">
                    <v-icon :color="item.Level.toLowerCase()">{{item.Level.toLowerCase()}}</v-icon> Level: {{item.Level}}
                  </v-flex>
                  <v-flex xs3 class="word_wrap">DateTime: {{showResultsTime(item.DateTime)}}</v-flex>
                  <v-flex xs6 class="word_wrap">Log Message: {{item.LogMessage}}</v-flex>
                </v-layout>
              </template>
              <v-card>
                <v-card-text :class="result_theme(item.Level.toLowerCase())" class="grey lighten-3">
                  <div v-for="(msg,j) in item.Items" :key="j">
                    <v-layout row wrap>
                      <v-flex xs4 class="word_wrap">{{showResultsTime(msg.DateTime)}}</v-flex>
                      <v-flex xs8 class="word_wrap">{{msg.Message}}</v-flex>
                    </v-layout>
                    <v-divider v-if="j!=item.Items.length-1"></v-divider>
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel><br>
          <div class="text-xs-center">
            <v-pagination v-model="page" :length="pageLength" :total-visible="7"></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <app-confirmation-modal v-model="searchError" max-width="500">
      <template slot="app-modal-title">ERROR</template>
      <template slot="app-modal-text">
        {{ errorMessage }}
      </template>
      <template slot="app-modal-actions">
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="searchError = false" outline>Cancel</v-btn>
      </template>
    </app-confirmation-modal>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
  import DateRange from '@/components/generic/DateRange'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  import moment from 'moment'
  import { createNamespacedHelpers } from 'vuex'
  import { format } from 'date-fns'
  import { prettyDateFormat, prettyDateTimeFormat } from '@/components/mixins/MomentUtil'
  const continuousimporterconfig = createNamespacedHelpers('continuousimporterconfig')

  export default {
    components: {
      DateRange,
      'app-confirmation-modal': AppConfirmationModal,
    },
    mixins: [SnackBarUtil],
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      importerId: {
        type: Number,
        required: true,
      },
      importerName: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        searchError: false,
        errorMessage: '',
        showLogs: false,
        startDate: null,
        endDate: null,
        startDateMenu: false,
        endDateMenu: false,
        minDate: null,
        maxDate: null,
        dates: {
          start: null,
          end: null,
        },
        formats: {
          prettyDateFormat,
        },
        availableData: [],
        queryString: '',
        errorsOnly: false,
        searchLoading: false,
        searchFinish: false,
        selectItem: {
          showDateTime: null,
          errorsOnly: false,
          queryString: '',
        },
        searchResults: [],
        page: 1,
        startIndex: 0,
      }
    },
    mounted() {
      this._updateFormValue(this.value)
    },
    computed: {
      ...continuousimporterconfig.mapGetters(['ImportersLogs']),
      shortcuts() {
        return {
          all: {
            hideClear: false,
            name: () => 'Select Date Time',
            hidden: true,
          },
        }
      },
      MinDate() {
        return moment(this.minDate).toDate()
      },
      MaxDate() {
        return moment(this.minDate).toDate()
      },
      showDateTime() {
        return `${format(this.dates.start, prettyDateFormat)} → ${format(this.dates.end, prettyDateFormat)}`
      },
      pageLength() {
        if (this.ImportersLogs.TotalNumber < 10) {
          return 1
        } else {
          return Math.ceil(this.ImportersLogs.TotalNumber / 10)
        }
      },
      logsNum() {
        let startNum
        let endNum
        if (this.ImportersLogs.TotalNumber == 0) {
          return 0
        } else if (this.ImportersLogs.TotalNumber < 10) {
          startNum = 1
          endNum = this.ImportersLogs.TotalNumber
        } else {
          startNum = this.ImportersLogs.StartIndex + 1
          endNum = this.page * 10 < this.ImportersLogs.TotalNumber ? this.page * 10 : this.ImportersLogs.TotalNumber
        }
        return `${startNum}-${endNum} of ${this.ImportersLogs.TotalNumber}`
      },
    },
    watch: {
      value(v) {
        this._updateFormValue(v)
      },
      showLogs(v) {
        this._emitChange(v)
      },
      page() {
        this.startIndex = (this.page - 1) * 10
        this.clickSearch()
      },
    },
    methods: {
      ...continuousimporterconfig.mapActions(['getImporterLogs']),
      _updateFormValue(v) {
        this.showLogs = v
      },
      _emitChange(v) {
        this.$emit('input', v)
      },
      close() {
        this._emitChange(false)
        this.clearAll()
      },
      result_theme(level) {
        if (level == 'info') {
          return 'theme_info'
        } else if (level == 'warning') {
          return 'theme_warning'
        } else if (level == 'error') {
          return 'theme_error'
        }
      },
      showResultsTime(DateTime) {
        return format(DateTime, prettyDateTimeFormat)
      },
      clearAll() {
        this.dates = {
          start: null,
          end: null,
        }
        this.queryString = ''
        this.errorsOnly = false
        this.searchLoading = false
        this.searchFinish = false
        this.selectItem = {
          showDateTime: null,
          errorsOnly: false,
          queryString: '',
        }
        this.searchResults = []
        this.page = 1
        this.startIndex = 0
      },
      async clickSearch() {
        let start = format(this.dates.start, 'YYYY-MM-DD')
        let end = format(this.dates.end, 'YYYY-MM-DD')
        let noDateTime = (start == '1970-01-01') || (end == '1970-01-01')
        if (noDateTime) {
          this.snackMessage = 'Please specify the date time for the query criteria.'
          this.snackColor = 'info'
          this.snackbar = true
        } else {
          this.searchFinish = false
          this.searchLoading = true
          let options = {
            StartDateTime: start,
            EndDateTime: end,
            ImporterId: this.importerId,
            ErrorsOnly: this.errorsOnly,
            StartIndex: this.startIndex,
            QueryString: this.queryString,
            Limit: 10,
          }
          await this.getImporterLogs(options)
            .then(() => {
              this.selectItem = {
                showDateTime: this.showDateTime,
                errorsOnly: this.errorsOnly,
                queryString: this.queryString,
              }
              this.searchResults = this.ImportersLogs.Data
              this.searchLoading = false
              this.searchFinish = true
            })
            .catch((error) => {
              console.error(error)
              this.searchLoading = false
              this.searchError = true
              this.errorMessage = error
            })
        }
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .theme_info {
    border: 3px solid #2196f3 !important;
  }

  .theme_warning {
    border: 3px solid #FFC107 !important;
  }

  .theme_error {
    border: 3px solid #b71c1c !important;
  }

  .word_wrap {
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
</style>